import {
  Boxes,
  Building2,
  Database,
  LayoutDashboard,
  LogOut,
  ServerCog
} from 'lucide-react';
import { NavLink, useNavigate } from '../../app/router';
import type { ReactNode } from 'react';
import { clearToken, readToken, superadminTokenKey } from '../../app/session';
import { Logo } from '../../components/Logo';
import { apiRequest } from '../../lib/api';

const navigation = [
  { to: '/superadmin/overview', label: 'Pregled', icon: LayoutDashboard },
  { to: '/superadmin/companies', label: 'Firme', icon: Building2 },
  { to: '/superadmin/modules', label: 'Moduli', icon: Boxes },
  { to: '/superadmin/infrastructure', label: 'Baze i backup', icon: Database },
  { to: '/superadmin/system', label: 'Sustav', icon: ServerCog }
];

export function SuperadminShell({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const token = readToken(superadminTokenKey);

  function logout() {
    void apiRequest('/api/v1/superadmin/auth/logout', {
      method: 'POST',
      accessToken: token
    }).catch(() => undefined);
    clearToken(superadminTokenKey);
    navigate('/superadmin/login', { replace: true });
  }

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <Logo />
        <nav className="admin-nav">
          {navigation.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) => (isActive ? 'is-active' : '')}
              >
                <Icon size={19} /> {item.label}
              </NavLink>
            );
          })}
        </nav>
        <button className="admin-profile" onClick={logout}>
          <span className="avatar">LB</span>
          <span><strong>Luka</strong><small>Superadmin</small></span>
          <LogOut size={17} />
        </button>
      </aside>
      <main className="admin-main">
        {children}
      </main>
    </div>
  );
}
